import React, { useState, useEffect } from 'react'
import {
  TextField,
  Button,
  Select,
  MenuItem,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
} from '@material-ui/core'

import {
  getTipos,
  postTipo,
  getEnsambladoras,
  deleteTipo,
  getPermisosByUser,
} from '@auteco/services/sostenibilidadService'

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(4),
  },
  tableContainer: {
    width: '60%',
    marginRight: theme.spacing(2),
  },
  table: {
    minWidth: 300,
    '& .MuiTableCell-root': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  formContainer: {
    width: '35%',
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    borderRadius: 4,
  },
  input: {
    backgroundColor: '#ffffff',
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#e0e0e0',
      },
    },
  },
  button: {
    marginTop: theme.spacing(1),
  },
}))

const PreciosSostenibilidadContainer = () => {
  const [tipos, setTipos] = useState([])

  const handleGetTipos = async () => {
    const response = await getTipos()
    setTipos(response.tipos)

    if (response) {
      console.log(response)
    }
  }

  const classes = useStyles()

  const [nombreMetaReduccion, setNombreMetaReduccion] = useState('')
  const [cantidadMetaReduccion, setCantidadMetaReduccion] = useState(null)

  // meta de aprovechamiento
  const [nombreMetaAprovechamiento, setNombreMetaAprovechamiento] = useState('')
  const [cantidadMetaAprovechamiento, setCantidadMetaAprovechamiento] = useState(null)

  // meta de reutilizacion
  const [nombreMetaReutilizacion, setNombreMetaReutilizacion] = useState('')
  const [cantidadMetaReutilizacion, setCantidadMetaReutilizacion] = useState(null)

  // corriente
const [nombreCorriente, setNombreCorriente] = useState('')
const [cantidadCorriente, setCantidadCorriente] = useState(null)
const [materialCorriente, setMaterialCorriente] = useState('')

  // costos fijos
  const [fechaCostoFijo, setFechaCostoFijo] = useState('')
  const [valorCostoFijo, setValorCostoFijo] = useState(null)


  const [nombreLlanta, setNombreLlanta] = useState('')
  const [precioLlanta, setPrecioLlanta] = useState(null)

  const [nombreMaterial, setNombreMaterial] = useState('')
  const [precioMaterial, setPrecioMaterial] = useState(null)

  const [nombreTipoResiduo, setNombreTipoResiduo] = useState('')
  const [nombreTipoEnergia, setNombreTipoEnergia] = useState('')
  const [nombreTipoAgua, setNombreTipoAgua] = useState('')
  const [nombreTipoContrato, setNombreTipoContrato] = useState('')
  const [nombreTipoServicio, setNombreTipoServicio] = useState('')
  const [nombreTipoEstrategia, setNombreTipoEstrategia] = useState('')
  const [materialTypeSelected, setMaterialTypeSelected] = useState('')
  const [ensambladoras, setEnsambladoras] = useState([])
  const [
    materialEnsambladoraSelected,
    setMaterialEnsambladoraSelected,
  ] = useState('')
  const [materialSedeSelected, setMaterialSedeSelected] = useState('')
  const [
    contratoEnsambladoraSelected,
    setContratoEnsambladoraSelected,
  ] = useState('')
  const [contratoSedeSelected, setContratoSedeSelected] = useState('')
  const [contratoServicioSelected, setContratoServicioSelected] = useState('')
  const [permisos, setPermisos] = useState(0)

  const handleGetEnsambladoras = async () => {
    const response = await getEnsambladoras()
    if (response && response.ensambladoras) {
      setEnsambladoras(response.ensambladoras)
    }
  }

  const handleGetPermisosByUser = async () => {
    const response = await getPermisosByUser()

    let bateriaPermiso = 0
    let llantaPermiso = 0
    let energiaPermiso = 0
    let aguaPermiso = 0
    let gasPermiso = 0
    let residuosPermiso = 0

    if (response) {
      for (let i = 0; i < response.permisos.length; i++) {
        if (response.permisos[i].nombre === 'Baterias') {
          bateriaPermiso = response.permisos[i].alcance
        } else if (response.permisos[i].nombre === 'Llantas') {
          llantaPermiso = response.permisos[i].alcance
        } else if (response.permisos[i].nombre === 'Energia') {
          energiaPermiso = response.permisos[i].alcance
        } else if (response.permisos[i].nombre === 'Agua') {
          aguaPermiso = response.permisos[i].alcance
        } else if (response.permisos[i].nombre === 'Gas') {
          gasPermiso = response.permisos[i].alcance
        } else if (response.permisos[i].nombre === 'Residuos') {
          residuosPermiso = response.permisos[i].alcance
        }

        setPermisos({
          bateria: bateriaPermiso,
          llanta: llantaPermiso,
          energia: energiaPermiso,
          agua: aguaPermiso,
          gas: gasPermiso,
          residuos: residuosPermiso,
        })
      }
      console.log({
        bateria: bateriaPermiso,
        llanta: llantaPermiso,
        energia: energiaPermiso,
        agua: aguaPermiso,
        gas: gasPermiso,
        residuos: residuosPermiso,
      })
    }
  }

  useEffect(() => {
    handleGetTipos()
    handleGetEnsambladoras()
    handleGetPermisosByUser()
  }, [])

  const [metaReduccion] = useState([
    { sede: 'Peligrosos', cantidad: 123 },
    { sede: 'No peligrosos', cantidad: 2424 },
  ])
  const [metaAprovechamiento] = useState([
    { sede: 'Peligrosos', cantidad: 123 },
    { sede: 'No peligrosos', cantidad: 2424 },
  ])
  const [metaReutilizacion] = useState([
    { sede: 'Peligrosos', cantidad: 123 },
    { sede: 'No peligrosos', cantidad: 2424 },
  ])

  const [corrientes] = useState([
    { clasificacion: 'Y12', tipoResiduo: '', estado: '' },
  ])

  const [costosFijos] = useState([{ fecha: '2024-04-11', valor: 23424 }])

  const handleSaveType = async (
    tipoId,
    nombre,
    cantidad,
    padreId,
    ensambladoraId,
    sedeId,
  ) => {
    const response2 = await postTipo({
      tipo_id: tipoId,
      nombre,
      cantidad,
      sede_id: sedeId || 0,
      fecha: '2024-08-06 10:00:00',
      ensambladora_id: parseInt(ensambladoraId, 10) || 0,
      padre_id: parseInt(padreId, 10) || 0,
    })

    console.log(response2, 'response2')
    if (response2) {
      console.log(response2)
    }
    handleGetTipos()
  }

  const handleDeleteType = async (id) => {
    const response = await deleteTipo(id)
    if (response) {
      handleGetTipos()
    }
  }

  return (
    <div>
      {/* Tipos de llantas */}
        <Typography variant="h6" gutterBottom>
          Tipos de llantas
        </Typography>
        <Grid container className={classes.section}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Modulo</TableCell>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Precio</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tipos &&
                  tipos
                    .filter((item) => item.tipo_id === '1')
                    .map((llanta, index) => (
                      <TableRow key={index}>
                        <TableCell>llantas</TableCell>
                        <TableCell>{llanta.nombre}</TableCell>
                        <TableCell>{llanta.cantidad}</TableCell>
                        <TableCell>
                          <Button onClick={() => handleDeleteType(llanta.id)}>
                            🗑
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Paper className={classes.formContainer}>
            {/* <Select
            fullWidth
            variant="outlined"
            displayEmpty
            className={classes.input}
          >
            <MenuItem value="" disabled>
              Modulo
            </MenuItem>
            <MenuItem value="ComboBox">ComboBox</MenuItem>
          </Select> */}
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              className={classes.input}
              value={nombreLlanta}
              onChange={(e) => setNombreLlanta(e.target.value)}
            />
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Precio"
              className={classes.input}
              value={precioLlanta}
              onChange={(e) => setPrecioLlanta(e.target.value)}
              type="number"
            />
            <Button
              onClick={() => handleSaveType(1, nombreLlanta, precioLlanta, 0)}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Guardar
            </Button>
          </Paper>
        </Grid>

      {/* Tipo residuos */}
      <Typography variant="h6" gutterBottom>
        Tipo residuos
      </Typography>
      <Grid container className={classes.section}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tipos
                .filter((item) => item.tipo_id === '3')
                .map((residuo, index) => (
                  <TableRow key={index}>
                    <TableCell>{residuo.nombre}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleDeleteType(residuo.id)}>
                        🗑
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper className={classes.formContainer}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre"
            className={classes.input}
            onChange={(e) => setNombreTipoResiduo(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => handleSaveType(3, nombreTipoResiduo, 0, 0)}
          >
            Guardar
          </Button>
        </Paper>
      </Grid>
      {/* Materiales */}
      <Typography variant="h6" gutterBottom>
        Materiales
      </Typography>
      <Grid container className={classes.section}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Material</TableCell>
                <TableCell>Ensambladora</TableCell>
                <TableCell>Sede</TableCell>
                <TableCell>Tipo</TableCell>
                <TableCell>Precio</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ensambladoras.length > 0 &&
                tipos
                  .filter((item) => item.tipo_id === '2')
                  .map((material, index) => (
                    <TableRow key={index}>
                      {/* <TableCell>{material.padre_id}</TableCell> */}
                   
                      <TableCell>{material.nombre}</TableCell>
                      <TableCell>
                        {material.ensambladora_id
                          ? ensambladoras.filter(
                              (item) => item.id === material.ensambladora_id,
                            )[0].nombre
                          : ''}
                      </TableCell>
                      <TableCell>
                        {material.ensambladora_id
                          ? ensambladoras
                              .filter(
                                (item) => item.id === material.ensambladora_id,
                              )[0]
                              .sedes.filter(
                                (sede) =>
                                  parseInt(sede.id, 10) ===
                                  parseInt(material.sede_id, 10),
                              )[0]?.nombre
                          : ''}
                      </TableCell>
                      <TableCell>
                        {material.padre_id
                          ? tipos.filter(
                              (item) => item.id === material.padre_id,
                            )[0].nombre
                          : ''}
                      </TableCell>
                      <TableCell>{material.cantidad}</TableCell>
                      <TableCell>
                        <Button onClick={() => handleDeleteType(material.id)}>
                          🗑️
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper className={classes.formContainer}>
          <Select
            value={materialEnsambladoraSelected}
            onChange={(e) => setMaterialEnsambladoraSelected(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Seleccionar Ensambladora
            </MenuItem>
            {ensambladoras &&
              ensambladoras.map((ensambladora, index) => (
                <MenuItem key={ensambladora.id} value={ensambladora.id}>
                  {ensambladora.nombre}
                </MenuItem>
              ))}
          </Select>

          <Select
            value={materialSedeSelected}
            onChange={(e) => setMaterialSedeSelected(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Seleccionar Sede
            </MenuItem>
            {ensambladoras.filter(
              (item) => item.id === materialEnsambladoraSelected,
            )[0] &&
              ensambladoras
                .filter((item) => item.id === materialEnsambladoraSelected)[0]
                .sedes.map((sede, index) => (
                  <MenuItem key={sede.id} value={sede.id}>
                    {sede.nombre}
                  </MenuItem>
                ))}
          </Select>

          <Select
            value={materialTypeSelected}
            onChange={(e) => setMaterialTypeSelected(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Seleccionar Tipo
            </MenuItem>
            {tipos
              .filter((item) => item.tipo_id === '3')
              .map((material, index) => (
                <MenuItem key={material.id} value={material.id}>
                  {material.nombre} {material.id}
                </MenuItem>
              ))}
          </Select>

          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre"
            className={classes.input}
            value={nombreMaterial}
            onChange={(e) => setNombreMaterial(e.target.value)}
          />
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Precio"
            className={classes.input}
            value={precioMaterial}
            onChange={(e) => setPrecioMaterial(e.target.value)}
            type="number"
          />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() =>
              handleSaveType(
                2,
                nombreMaterial,
                precioMaterial,
                materialTypeSelected,
                materialEnsambladoraSelected,
                materialSedeSelected,
              )
            }
          >
            Guardar
          </Button>
        </Paper>
      </Grid>

      {/* Tipo Energía */}
      
      <Typography variant="h6" gutterBottom>
        Tipo Energía
      </Typography>
      <Grid container className={classes.section}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tipos
                .filter((item) => item.tipo_id === '4')
                .map((energia, index) => (
                  <TableRow key={index}>
                    <TableCell>{energia.nombre}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleDeleteType(energia.id)}>
                        🗑
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper className={classes.formContainer}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre"
            className={classes.input}
            onChange={(e) => setNombreTipoEnergia(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => handleSaveType(4, nombreTipoEnergia, 0, 0)}
          >
            Guardar
          </Button>
        </Paper>
      </Grid>
      {/* Tipo Agua */}
     
      <Typography variant="h6" gutterBottom>
        Tipo Agua
      </Typography>
      <Grid container className={classes.section}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tipos
                .filter((item) => item.tipo_id === '5')
                .map((agua, index) => (
                  <TableRow key={index}>
                    <TableCell>{agua.nombre}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleDeleteType(agua.id)}>
                        🗑
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper className={classes.formContainer}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre"
            className={classes.input}
            onChange={(e) => setNombreTipoAgua(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => handleSaveType(5, nombreTipoAgua, 0, 0)}
          >
            Guardar
          </Button>
        </Paper>
      </Grid>
      {/* Tipo Servicio */}
      <Typography variant="h6" gutterBottom>
        Tipo Servicio
      </Typography>
      <Grid container className={classes.section}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tipos
                .filter((item) => item.tipo_id === '13')
                .map((agua, index) => (
                  <TableRow key={index}>
                    <TableCell>{agua.nombre}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleDeleteType(agua.id)}>
                        🗑
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper className={classes.formContainer}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre"
            className={classes.input}
            onChange={(e) => setNombreTipoServicio(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => handleSaveType(13, nombreTipoServicio, 0, 0)}
          >
            Guardar
          </Button>
        </Paper>
      </Grid>

      {/* Tipo Contrato */}
      <Typography variant="h6" gutterBottom>
        Tipo Contrato
      </Typography>
      <Grid container className={classes.section}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Nombre</TableCell>
                <TableCell>Ensambladora</TableCell>
                <TableCell>Sede</TableCell>
                <TableCell>Servicio</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tipos
                .filter((item) => item.tipo_id === '6')
                .map((contrato, index) => (
                  <TableRow key={index}>
                    <TableCell>{contrato.nombre}</TableCell>
                    <TableCell>
                      {ensambladoras.length > 0 && contrato.ensambladora_id
                        ? (() => {
                            const filteredEnsambladora = ensambladoras.filter(
                              (item) => item.id === contrato.ensambladora_id
                            )[0];
                            return filteredEnsambladora?.nombre || '';
                          })()
                        : ''}
                    </TableCell>
                    <TableCell>
                      {ensambladoras.length > 0 && contrato.ensambladora_id
                        ? (() => {
                            const filteredEnsambladora = ensambladoras.filter(
                              (item) => item.id === contrato.ensambladora_id
                            )[0];
                            const filteredSede = filteredEnsambladora?.sedes?.filter(
                              (sede) =>
                                parseInt(sede.id, 10) ===
                                parseInt(contrato.sede_id, 10)
                            )[0];
                            return filteredSede?.nombre || '';
                          })()
                        : ''}
                    </TableCell>
                    <TableCell>
                      {contrato.padre_id
                        ? tipos.filter(
                            (item) => item.id === contrato.padre_id,
                          )[0].nombre
                        : ''}
                    </TableCell>
                    <TableCell>
                      <Button onClick={() => handleDeleteType(contrato.id)}>
                        🗑
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper className={classes.formContainer}>
          <Select
            value={contratoEnsambladoraSelected}
            onChange={(e) => setContratoEnsambladoraSelected(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Seleccionar Ensambladora
            </MenuItem>
            {ensambladoras &&
              ensambladoras.map((ensambladora, index) => (
                <MenuItem key={ensambladora.id} value={ensambladora.id}>
                  {ensambladora.nombre}
                </MenuItem>
              ))}
          </Select>

          <Select
            value={contratoSedeSelected}
            onChange={(e) => setContratoSedeSelected(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Seleccionar Sede
            </MenuItem>
            {ensambladoras.filter(
              (item) => item.id === contratoEnsambladoraSelected,
            )[0] &&
              ensambladoras
                .filter((item) => item.id === contratoEnsambladoraSelected)[0]
                .sedes.map((sede, index) => (
                  <MenuItem key={sede.id} value={sede.id}>
                    {sede.nombre}
                  </MenuItem>
                ))}
          </Select>

          <Select
            value={contratoServicioSelected}
            onChange={(e) => setContratoServicioSelected(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Seleccionar Tipo
            </MenuItem>
            {tipos
              .filter((item) => item.tipo_id === '13')
              .map((servicio, index) => (
                <MenuItem key={servicio.id} value={servicio.id}>
                  {servicio.nombre} 
                </MenuItem>
              ))}
          </Select>

          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre"
            className={classes.input}
            onChange={(e) => setNombreTipoContrato(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() =>
              handleSaveType(
                6,
                nombreTipoContrato,
                0,
                contratoServicioSelected,
                contratoEnsambladoraSelected,
                contratoSedeSelected,
              )
            }
          >
            Guardar
          </Button>
        </Paper>
      </Grid>

      {/* Estrategias */}
      <Typography variant="h6" gutterBottom>
        Tipo Estrategia
      </Typography>
      <Grid container className={classes.section}>
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Tipo</TableCell>
                <TableCell>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tipos
                .filter((item) => item.tipo_id === '7')
                .map((estrategia, index) => (
                  <TableRow key={index}>
                    <TableCell>{estrategia.nombre}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleDeleteType(estrategia.id)}>
                        🗑
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Paper className={classes.formContainer}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Nombre"
            className={classes.input}
            onChange={(e) => setNombreTipoEstrategia(e.target.value)}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={() => handleSaveType(7, nombreTipoEstrategia, 0, 0)}
          >
            Guardar
          </Button>
        </Paper>
      </Grid>

       {/* Meta de reducción */}
       <Typography variant="h6" gutterBottom>
          Meta de reducción
        </Typography>
        <Grid container className={classes.section}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Meta</TableCell>
                  <TableCell>Cantidad</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tipos &&
                  tipos
                    .filter((item) => item.tipo_id === '8')
                    .map((llanta, index) => (
                      <TableRow key={index}>
                        <TableCell>{llanta.nombre}</TableCell>
                        <TableCell>{llanta.cantidad}</TableCell>
                        <TableCell>
                          <Button onClick={() => handleDeleteType(llanta.id)}>
                            🗑
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Paper className={classes.formContainer}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              className={classes.input}
              value={nombreMetaReduccion}
              onChange={(e) => setNombreMetaReduccion(e.target.value)}
            />
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Cantidad"
              className={classes.input}
              value={cantidadMetaReduccion}
              onChange={(e) => setCantidadMetaReduccion(e.target.value)}
              type="number"
            />
            <Button
              onClick={() => handleSaveType(8, nombreMetaReduccion, cantidadMetaReduccion, 0)}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Guardar
            </Button>
          </Paper>
        </Grid>

      {/* Meta de aprovechamiento */}
      <Typography variant="h6" gutterBottom>
          Meta de aprovechamiento
        </Typography>
        <Grid container className={classes.section}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Meta</TableCell>
                  <TableCell>Cantidad</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tipos &&
                  tipos
                    .filter((item) => item.tipo_id === '9')
                    .map((llanta, index) => (
                      <TableRow key={index}>
                        <TableCell>{llanta.nombre}</TableCell>
                        <TableCell>{llanta.cantidad}</TableCell>
                        <TableCell>
                          <Button onClick={() => handleDeleteType(llanta.id)}>
                            🗑
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Paper className={classes.formContainer}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              className={classes.input}
              value={nombreMetaAprovechamiento}
              onChange={(e) => setNombreMetaAprovechamiento(e.target.value)}
            />
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Cantidad"
              className={classes.input}
              value={cantidadMetaAprovechamiento}
              onChange={(e) => setCantidadMetaAprovechamiento(e.target.value)}
              type="number"
            />
            <Button
              onClick={() => handleSaveType(9, nombreMetaAprovechamiento, cantidadMetaAprovechamiento, 0)}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Guardar
            </Button>
          </Paper>
        </Grid>
      



      {/* Meta de reutilización */}
      <Typography variant="h6" gutterBottom>
          Meta de reutilización
        </Typography>
        <Grid container className={classes.section}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Meta</TableCell>
                  <TableCell>Cantidad</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tipos &&
                  tipos
                    .filter((item) => item.tipo_id === '10')
                    .map((llanta, index) => (
                      <TableRow key={index}>
                        <TableCell>{llanta.nombre}</TableCell>
                        <TableCell>{llanta.cantidad}</TableCell>
                        <TableCell>
                          <Button onClick={() => handleDeleteType(llanta.id)}>
                            🗑
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Paper className={classes.formContainer}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              className={classes.input}
              value={nombreMetaReutilizacion}
              onChange={(e) => setNombreMetaReutilizacion(e.target.value)}
            />
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Cantidad"
              className={classes.input}
              value={cantidadMetaReutilizacion}
              onChange={(e) => setCantidadMetaReutilizacion(e.target.value)}
              type="number"
            />
            <Button
              onClick={() => handleSaveType(10, nombreMetaReutilizacion, cantidadMetaReutilizacion, 0)}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Guardar
            </Button>
          </Paper>
        </Grid>

      {/* Corriente */}
      <Typography variant="h6" gutterBottom>
          Corriente
        </Typography>
        <Grid container className={classes.section}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Corriente</TableCell>
                  <TableCell>Alcance</TableCell>
                  <TableCell>Material</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tipos &&
                  tipos
                    .filter((item) => item.tipo_id === '11')
                    .map((corriente, index) => (
                      <TableRow key={index}>
                        <TableCell>{corriente.nombre}</TableCell>
                        <TableCell>{corriente.cantidad}</TableCell>
                        <TableCell>
                          {corriente.padre_id
                            ? tipos.filter(
                                (item) => item.id === corriente.padre_id,
                              )[0].nombre
                            : ''}
                          </TableCell>
                        <TableCell>
                          <Button onClick={() => handleDeleteType(corriente.id)}>
                            🗑
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Paper className={classes.formContainer}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              className={classes.input}
              value={nombreCorriente}
              onChange={(e) => setNombreCorriente(e.target.value)}
            />
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Alcance"
              className={classes.input}
              value={cantidadCorriente}
              onChange={(e) => setCantidadCorriente(e.target.value)}
              type="number"
            />
            <Select
            value={contratoServicioSelected}
            onChange={(e) => setMaterialCorriente(e.target.value)}
            displayEmpty
            fullWidth
          >
            <MenuItem value="" disabled>
              Seleccionar Tipo
            </MenuItem>
            {tipos
              .filter((item) => item.tipo_id === '2')
              .map((material, index) => (
                <MenuItem key={material.id} value={material.id}>
                  {material.nombre} 
                </MenuItem>
              ))}
          </Select>
           
            <Button
              onClick={() => handleSaveType(11, nombreCorriente, cantidadCorriente, materialCorriente)}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Guardar
            </Button>
          </Paper>
        </Grid>

      {/* Costos fijos */}
      <Typography variant="h6" gutterBottom>
          Costos fijos
        </Typography>
        <Grid container className={classes.section}>
          <TableContainer component={Paper} className={classes.tableContainer}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Valor</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tipos &&
                  tipos
                    .filter((item) => item.tipo_id === '12')
                    .map((llanta, index) => (
                      <TableRow key={index}>
                        <TableCell>{llanta.nombre}</TableCell>
                        <TableCell>{llanta.cantidad}</TableCell>
                        <TableCell>
                          <Button onClick={() => handleDeleteType(llanta.id)}>
                            🗑
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Paper className={classes.formContainer}>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Nombre"
              className={classes.input}
              value={fechaCostoFijo}
              onChange={(e) => setFechaCostoFijo(e.target.value)}
            />
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Valor"
              className={classes.input}
              value={valorCostoFijo}
              onChange={(e) => setValorCostoFijo(e.target.value)}
              type="number"
            />
            <Button
              onClick={() => handleSaveType(12, fechaCostoFijo, valorCostoFijo, 0)}
              fullWidth
              variant="contained"
              color="primary"
              className={classes.button}
            >
              Guardar
            </Button>
          </Paper>
        </Grid>
    </div>
  )
}

export default PreciosSostenibilidadContainer
